import { useSearch } from '@tanstack/react-router';
import { AssumptionsForm } from '@/features/assumptions/AssumptionsForm';
import { SimulateurTabs } from '@/features/simulations/SimulateurTabs';
import { useAssumptions } from '@/features/simulations/queries';
import { ApiRequestError } from '@/lib/api';

export function SimulateurHypothesesPage() {
  const assumptions = useAssumptions();
  const { housingPriceGrowth } = useSearch({ strict: false }) as { housingPriceGrowth?: number };

  // Aucune version n'existe encore : 404 attendu, on propose les valeurs du classeur.
  const notSet = assumptions.error instanceof ApiRequestError && assumptions.error.code === 'assumptions_not_set';

  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">Simulateur</h1>
      <SimulateurTabs />
      {assumptions.isPending && <p className="text-muted-foreground">Chargement…</p>}
      {assumptions.isError && !notSet && (
        <p className="text-destructive">Impossible de lire les hypothèses actuelles.</p>
      )}
      {(assumptions.data || notSet) && (
        <AssumptionsForm
          // Une nouvelle version (ou une nouvelle suggestion) repart d'un formulaire neuf.
          key={`${assumptions.data?.id ?? 'none'}-${housingPriceGrowth ?? ''}`}
          current={assumptions.data ?? null}
          suggestedGrowth={housingPriceGrowth}
        />
      )}
    </div>
  );
}
